import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { ENV_ANDROID, ENV_IOS } from '../../const';
import { env } from '../../getNativeInfo';
import { notInApp } from '../not-in-app';
/**
 * 客户端 JSAPI 统一调用方法
 *
 * *大部分场景下，使用该方法能抹除平台差异*
 */
export function uniCall(_a) {
  var _b;
  var api = _a.api,
    param = _a.param,
    _c = _a.prefix,
    prefix = _c === void 0 ? 'bcz_system' : _c,
    envOnly = _a.envOnly;
  if (env && Array.isArray(envOnly) && !envOnly.includes(env)) {
    throw new Error("\u5F53\u524D\u73AF\u5883 (".concat(env, ") \u4E0D\u652F\u6301 ").concat(api, " \u63A5\u53E3\u8C03\u7528"));
  }
  // 兼容传入普通对象的场景
  if (param && typeof param === 'object' && !Array.isArray(param)) {
    param = JSON.stringify(param);
  }
  if (env === ENV_IOS) {
    if (!window.webkit.messageHandlers["".concat(prefix, "_").concat(api)]) {
      throw new Error("[uniCall] window.webkit.messageHandlers['".concat(prefix, "_").concat(api, "'] is null or undefined"));
    }
    window.webkit.messageHandlers["".concat(prefix, "_").concat(api)].postMessage(param !== null && param !== void 0 ? param : '');
  } else if (env === ENV_ANDROID) {
    if (typeof window[prefix][api] !== 'function') {
      throw new Error("[uniCall] window.".concat(prefix, ".").concat(api, " is not a function"));
    }
    // `.api()` 和 `.api(undefined)` 行为不一样，在安卓环境下，后者会报错
    (_b = window[prefix])[api].apply(_b, [param].filter(function (i) {
      return Boolean(i) || i === '' || i === 0;
    }));
  } else {
    throw notInApp({
      api: api,
      param: param
    });
  }
}